import { every, find } from 'lodash'

export class Pipeline {
  events = []

  constructor(events) {
    this.events = events
  }

  get isComplete() {
    return every(this.events, {
      complete: true
    })
  }

  findEventByName(name) {
    return find(this.events, { name })
  }

  markEventAsComplete({ name }) {
    const event = this.findEventByName(name)
    if (event) event.markAsComplete()
  }
}
